import { render, staticRenderFns } from "./OrderInfoCard.vue?vue&type=template&id=64e62d26"
import script from "./OrderInfoCard.vue?vue&type=script&lang=ts"
export * from "./OrderInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports